/**
 * AssessmentHeader - Shared header component for PreK assessments
 *
 * Displays warmup badge and timer in a consistent layout
 */

import React, { useState, useCallback } from 'react';
import TimerDisplay from './TimerDisplay';

export const TIMER_HIDDEN_KEY = 'fastmath-k-timer-hidden';

interface AssessmentHeaderProps {
  isWarmup: boolean;
  showTimer: boolean;
  wallClockTimeRemaining: number;
  wallClockStarted: boolean;
  isTTSPlaying?: boolean;
  timerHideable?: boolean;
}

const AssessmentHeader: React.FC<AssessmentHeaderProps> = ({
  isWarmup,
  showTimer,
  wallClockTimeRemaining,
  wallClockStarted,
  isTTSPlaying = false,
  timerHideable = false,
}) => {
  const [timerHidden, setTimerHidden] = useState(() => {
    if (!timerHideable) return false;
    return localStorage.getItem(TIMER_HIDDEN_KEY) === 'true';
  });

  const handleTimerToggle = useCallback(() => {
    setTimerHidden(prev => {
      const next = !prev;
      localStorage.setItem(TIMER_HIDDEN_KEY, String(next));
      return next;
    });
  }, []);

  return (
    <div className="flex justify-between items-center p-6">
      {/* Warmup Indicator */}
      {isWarmup ? (
        <div className="bg-yellow-400 text-yellow-900 px-6 py-3 rounded-full font-bold text-lg shadow-lg">
          🏃‍♀️ Practice Round
        </div>
      ) : (
        <div></div>
      )}

      {/* Timer Display */}
      {showTimer && !isWarmup && (
        <TimerDisplay
          timeRemaining={wallClockTimeRemaining}
          isRunning={wallClockStarted}
          isTTSPlaying={isTTSPlaying}
          hideProgress={timerHideable && timerHidden}
          onClick={timerHideable ? handleTimerToggle : undefined}
        />
      )}
    </div>
  );
};

export default AssessmentHeader;
